/*
  Drapers — 18+ age gate.
  Blocks the store on first visit until the visitor confirms they are 18+.
  The choice is remembered in localStorage (with an expiry) so it only shows
  once per remember-window. Confirming also sets a cart attribute flag on the
  next add so age acknowledgement is recorded server-side.

  Progressive enhancement: if JS is disabled the gate never blocks the store
  (the notice remains visible in the footer + on every PDP).
*/
(function () {
  var root = document.getElementById('drapers-age-gate');
  if (!root) return;

  var KEY = 'drapers_age_ok';
  var days = parseInt(root.getAttribute('data-remember-days'), 10) || 30;
  var leaveUrl = root.getAttribute('data-leave-url') || 'https://www.google.com';

  function isVerified() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return false;
      var until = parseInt(raw, 10);
      if (!until || Date.now() > until) {
        localStorage.removeItem(KEY);
        return false;
      }
      return true;
    } catch (e) {
      // Fall back to a session cookie check if storage is blocked
      return document.cookie.indexOf(KEY + '=1') !== -1;
    }
  }

  function setVerified() {
    var until = Date.now() + days * 24 * 60 * 60 * 1000;
    try {
      localStorage.setItem(KEY, String(until));
    } catch (e) {
      document.cookie = KEY + '=1; path=/; max-age=' + days * 86400;
    }
  }

  var lastFocus;
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('drapers-age-locked');
    var confirmBtn = root.querySelector('[data-age-confirm]');
    if (confirmBtn) confirmBtn.focus();
    document.addEventListener('keydown', trap, true);
  }

  function close() {
    root.hidden = true;
    document.documentElement.classList.remove('drapers-age-locked');
    document.removeEventListener('keydown', trap, true);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Simple focus trap — keep tab focus inside the dialog while it is open
  function trap(e) {
    if (e.key !== 'Tab') return;
    var focusables = root.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  root.addEventListener('click', function (e) {
    var confirm = e.target.closest('[data-age-confirm]');
    var leave = e.target.closest('[data-age-leave]');
    if (confirm) {
      setVerified();
      close();
    } else if (leave) {
      window.location.href = leaveUrl;
    }
  });

  if (!isVerified()) {
    // Reveal after DOM is ready to avoid a flash before styles apply
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', open);
    } else {
      open();
    }
  }
})();
